import { isProductionServer } from 'root/stores/routes/APP_URLS';

import { REMOVE_FIRST_SHOWN_ERROR, SET_ERRORS_AS_SHOWN } from '../constants';
import overwriteNetworkMessage from '../overwriteNetworkMessage';

export const doSetErrorsAsShown =
  ({ errorsToShow, errorsLookup }) =>
  ({ dispatch }) => {
    try {
      dispatch({ type: SET_ERRORS_AS_SHOWN });

      const errorCount = errorsToShow.length;

      // no errors, ignore
      if (!errorCount) return;

      let message = 'Uncaught Error';

      try {
        const errorConstant = errorsToShow[0];
        const errorObj = errorsLookup[errorConstant];
        const errorObjMsg = Array.isArray(errorObj.message)
          ? errorObj.message[0]
          : errorObj.message;
        let msg = overwriteNetworkMessage({
          errorConstant,
          message: errorObjMsg,
        });
        // capitalize the first letter in the string so it doesn't look like sh*t
        msg = msg.replace(/^\w/, (c) => c.toUpperCase());

        message =
          process.env.NODE_ENV === 'production' && isProductionServer
            ? `${msg}`
            : `[${errorCount}] ${errorConstant}: ${msg}`;
      } catch (err) {
        message = 'Unknown Error';
      }

      dispatch({ type: REMOVE_FIRST_SHOWN_ERROR });
      dispatch({
        actionCreator: 'doCreateNotificationMessage',
        args: [{ message }],
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn(error);
    }
  };
